import Api from '@/api/index'

export default {
  data() {
    return {
      extracts: {},
      loading: false,
    }
  },
  methods: {
    getExtract(kind) {
      let filter = {
        kind,
        date: this.day_selected,
        begin_date: this.$moment(this.day_selected+'T12:00:00').startOf('day').toISOString(),
        end_date: this.$moment(this.day_selected+'T12:00:00').endOf('day').toISOString(),
      }
      this.loading = true
      Api.IncomeExtract.index(filter).then(r=> r.data).then(d=>{
        d = d.data? d.data.map(b=> b.attributes) : d
        this.extracts = {...d}
      }).finally(()=> {
        setTimeout(() => {
          this.loading = false
        }, 500);
      })
    },
  },
}